import React from "react";
import { useTranslation } from "react-i18next";
import { CheckCircle, XCircle } from "lucide-react";
import { Badge } from "../ui/badge";

const ImportPreviewStep = ({ validationResult }) => {
  const { t } = useTranslation();

  return (
  <div className="space-y-4">
    <div className="grid grid-cols-3 gap-4">
      <div className="bg-muted/50 rounded-lg p-4 text-center">
        <p className="text-2xl font-bold text-foreground">{validationResult.total_lines}</p>
        <p className="text-sm text-muted-foreground">{t("importEmployees.preview.totalLines")}</p>
      </div>
      <div className="bg-green-950/20 rounded-lg p-4 text-center">
        <p className="text-2xl font-bold text-green-400">{validationResult.valid_lines}</p>
        <p className="text-sm text-muted-foreground">{t("importEmployees.preview.validLines")}</p>
      </div>
      <div className="bg-red-950/20 rounded-lg p-4 text-center">
        <p className="text-2xl font-bold text-red-400">{validationResult.error_lines}</p>
        <p className="text-sm text-muted-foreground">{t("importEmployees.preview.errorLines")}</p>
      </div>
    </div>

    {validationResult.can_import ? (
      <div className="bg-green-950/20 border border-green-900/40 rounded-lg p-4 flex items-start space-x-3">
        <CheckCircle className="h-5 w-5 text-green-400 mt-0.5" />
        <div>
          <h4 className="font-semibold text-foreground">{t("importEmployees.preview.readyTitle")}</h4>
          <p className="text-sm text-muted-foreground mt-1">
            {t("importEmployees.preview.readyDesc")}
          </p>
        </div>
      </div>
    ) : (
      <div className="bg-red-950/20 border border-red-900/40 rounded-lg p-4 flex items-start space-x-3">
        <XCircle className="h-5 w-5 text-red-400 mt-0.5" />
        <div>
          <h4 className="font-semibold text-foreground">{t("importEmployees.preview.errorsTitle")}</h4>
          <p className="text-sm text-muted-foreground mt-1">
            {t("importEmployees.preview.errorsDesc")}
          </p>
        </div>
      </div>
    )}

    {validationResult.error_lines > 0 && (
      <div className="max-h-64 overflow-y-auto border rounded-lg">
        <table className="w-full text-sm">
          <thead className="bg-muted/50 sticky top-0">
            <tr>
              <th className="px-4 py-2 text-left">{t("importEmployees.table.line")}</th>
              <th className="px-4 py-2 text-left">{t("importEmployees.table.registrationNumber")}</th>
              <th className="px-4 py-2 text-left">{t("importEmployees.table.errors")}</th>
            </tr>
          </thead>
          <tbody>
            {validationResult.validation_results
              .filter((r) => !r.valid)
              .map((result, index) => (
                <tr key={index} className="border-t">
                  <td className="px-4 py-2">{result.line}</td>
                  <td className="px-4 py-2">{result.data.matricule || "-"}</td>
                  <td className="px-4 py-2">
                    <div className="space-y-1">
                      {result.errors.map((error, i) => (
                        <Badge key={i} variant="destructive" className="mr-1">
                          {error}
                        </Badge>
                      ))}
                    </div>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    )}
  </div>
  );
};

export default ImportPreviewStep;
